import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user-page"
}

import { computed, onMounted, reactive } from 'vue';
import {
    GetStudentMenuPageResponseModel,
    StudentStatus,
} from '@/http/pageModels/studentModels/menuPage/GetStudentMenuPageResponseModel';
import { getStudentMenuPage } from './apiMethods';
import { useRouter } from 'vue-router';
import MenuList from '@/common/components/snedson-material-components/menu-list/menu-list.vue';
import UserHeader from '@/common/components/snedson-material-components/user-header/user-header.vue';
import AuthService from '@/services/AuthService';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPage',
  setup(__props) {

const state = reactive<{ data: GetStudentMenuPageResponseModel | null }>({
    data: null,
});

const router = useRouter();

const onChangeStatusButtonClick = () => {
    router.push({ name: 'sn.student.user.setStatus' });
};

const currentStatus = computed((): StudentStatus | null => {
    if (!state.data) {
        return null;
    }

    return state.data?.allStatusesForStudents[
        state.data.allStatusesForStudents.findIndex(
            (value) => value.statusID === state.data?.currentStatusID
        )
    ];
});

onMounted(() => {
    getStudentMenuPage().then((res) => {
        state.data = res.data;
        console.log(res);
    });
});

return (_ctx: any,_cache: any) => {
  return (state.data !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(UserHeader, {
          props: {
                name: state.data.name,
                surname: state.data.surname,
                //patronymic: state.data.patronymic,
                subheaderIcon: _unref(currentStatus)?.iconURL,
                subheader: _unref(currentStatus)?.statusName,
            }
        }, null, 8, ["props"]),
        _createVNode(MenuList, {
          props: {
                items: [
                    {
                        icon: 'person_pin_circle',
                        title: 'Статус посещения',
                        content: `Текущий: ${_unref(currentStatus)?.statusName}`,
                        button: {
                            iconName: 'edit',
                            innerText: 'Сменить',
                            size: 'full-resizable-to-icon-large',
                            type: 'text',
                        },
                        buttonCallback: onChangeStatusButtonClick,
                    },
                    {
                        icon: 'info',
                        title: 'Данные класса',
                    },
                    {
                        icon: 'school',
                        title: 'Данные школы',
                    },
                    {
                        icon: 'logout',
                        title: 'Выход из аккаунта',
                        button: {
                            type: 'text',
                            iconName: 'logout',
                            innerText: 'Выйти',
                            size: 'full-resizable-to-icon-large',
                        },
                        buttonCallback: _unref(AuthService).logout,
                    },
                ],
            }
        }, null, 8, ["props"])
      ]))
    : _createCommentVNode("", true)
}
}

})